module.exports = "<p>\n  promotiondetails-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/promotiondetails/promotiondetails-form/promotiondetails-form.component.html
// module id = ./src/app/hrms/serviceregister/promotiondetails/promotiondetails-form/promotiondetails-form.component.html
// module chunks = main